import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  HttpService,
  NotificationService,
  PurchaseOrderPurchaseAllocation,
  TmsWebBaseEditCreateService,
} from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderPurchaseAllocationService extends TmsWebBaseEditCreateService<
  PurchaseOrderPurchaseAllocation,
  PurchaseOrderPurchaseAllocation
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super(
      'PurchaseOrderPurchaseAllocation',
      $localize`Purchase Order Purchase Allocation`,
      httpService,
      notificationService,
    );
  }

  allocate(purchaseOrderLineId: string, PurchaseOrderLineId: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      purchaseOrderLineId,
      PurchaseOrderLineId,
    });
  }

  updatePurchaseOrderPurchaseAllocation(purchaseOrderPurchaseAllocationId: string, quantity: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdatePurchaseOrderPurchaseAllocation`, {
      purchaseOrderPurchaseAllocationId,
      quantity,
    });
  }

  getAllocations(purchaseOrderLineId: any): Observable<PurchaseOrderPurchaseAllocation[]> {
    return this.httpService.get<PurchaseOrderPurchaseAllocation[]>(
      `${this.apiUrl}/GetAllocations?purchaseOrderLineId=${purchaseOrderLineId}`,
    );
  }
}
